import { SetStateAction, useCallback } from 'react';
import { Icon } from '@repo/ui';
import c from 'classnames';

import styles from './TaxonomyCategoryFilters.module.css';
import { Button } from 'components';

export interface TaxonomyCategoryFilterType {
  title: string;
  value: string;
  active: boolean;
}

export const initialValues: TaxonomyCategoryFilterType[] = [
  { title: 'Species', value: 'species', active: true },
  { title: 'Genus', value: 'genus', active: false },
  { title: 'Family', value: 'family', active: false },
  { title: 'Phylum', value: 'phylum', active: false },
];

interface TaxonomyCategoryFiltersProps {
  filters: TaxonomyCategoryFilterType[];
  setFilters: React.Dispatch<SetStateAction<TaxonomyCategoryFilterType[]>>;
  onFilterChange?: (value: string) => void;
}

export const TaxonomyCategoryFilters = ({
  filters,
  setFilters,
  onFilterChange,
}: TaxonomyCategoryFiltersProps) => {
  const handleFilterClick = useCallback(
    (index: number) => {
      let selectedValue = '';
      const newFilters = filters.map((filter, i) => {
        const isActive = i === index;
        if (isActive) {
          selectedValue = filter.value;
        }
        return {
          ...filter,
          active: isActive,
        };
      });
      setFilters(newFilters);
      onFilterChange?.(selectedValue);
    },
    [filters, setFilters, onFilterChange],
  );

  return (
    <fieldset className={styles.filterContainer}>
      <div className={styles.filterRow}>
        <Icon name='filterLines' size='m' />{' '}
        {filters.map((filter, index) => (
          <Button
            key={filter.title}
            variant='wrapper'
            className={c(styles.filterButton, {
              [styles.active]: filter.active,
            })}
            onClick={() => handleFilterClick(index)}
          >
            {filter.title}
          </Button>
        ))}
      </div>
    </fieldset>
  );
};
